/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off', no-unreachable: 'off' */
import $ from 'jquery'
import reportModelBuilder from '@/scripts/crossTabulation/reportModelBuilder'
import apiHelper from '@/scripts/crossTabulation/apiHelper'
import commonApiHelper from '@/scripts/commonApiHelper'
import current from '@/scripts/current';
import store from '@/store';
import metricsHelper from '@/scripts/metricsHelper';
import commonTestHelper from '../commonTestHelper';

export default {
    loadFromCachedData: process.env.NODE_ENV === 'development' && false,
    addSelectionParameters,
    addSelectionParametersSmall,
    getReportParameters,
    getJsonFileName,
    loadCachedData,
    saveLogData,
    loadFromApi,
    loadFromApi2,
    loadFromApiCompare,
    downloadJson,
    populateReportModel,
    callGet
}
function addSelectionParameters(parameters, selectionModel) {
    commonApiHelper.addYearAndLocation(parameters);
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.row, 'row_var');
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.column, 'column_var');
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.control1, 'control_var1');
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.control2, 'control_var2');

    var statistics = selectionModel.selectedStatistics;
    var theStatistics = [];
    if (statistics.weightedN)
        theStatistics.push('weighted_n');
    // //TAC Remove
    // if (statistics.totalPercentage)
    //   theStatistics.push('total_percentage');
    // if (statistics.rowPercentage)
    //   theStatistics.push('row_percentage');
    // if (statistics.columnPercentage)
    //   theStatistics.push('column_percentage');
    //TAC Remove
    if (theStatistics.length > 0)
        parameters.push({ queryCode: 'statistics', value: theStatistics.join(',') });

    var additionalStatistics = [];
    // if (statistics.standardError)//TAC Remove
    //   additionalStatistics.push('standard_error');//TAC Remove
    if (statistics.confidenceInterval)
        additionalStatistics.push('confidence_interval');
    if (additionalStatistics.length > 0)
        parameters.push({ queryCode: 'additional_statistics', value: additionalStatistics.join(',') });

    // if (statistics.chiSquare)//TAC Remove
    //   parameters.push({ key: 'include_chi_square_test', value: 'true' });//TAC Remove
    if (statistics.nonResponse)
        parameters.push({ queryCode: 'include_non_response_levels', value: 'true' });
    // if (statistics.sampleSize)//TAC Remove
    //   parameters.push({ key: 'include_sample_size', value: 'true' });//TAC Remove
}

function addSelectionParametersSmall(parameters, selectionModel) {
    commonApiHelper.addYearAndLocationSmall(parameters);
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.row, 'r');
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.column, 'c');
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.control1, 'c1');
    commonApiHelper.addVariableParameter(parameters, selectionModel.v.control2, 'c2');

    var statistics = selectionModel.selectedStatistics;
    var theStatistics = [];
    if (statistics.rowPercentage)
        theStatistics.push('r');
    if (statistics.columnPercentage)
        theStatistics.push('c');
    if (statistics.totalPercentage)
        theStatistics.push('t');
    if (statistics.weightedN)
        theStatistics.push('w');
    if (theStatistics.length > 0)
        parameters.push({ queryCode: 's', value: theStatistics.join(',') });

    var additionalStatistics = [];
    if (statistics.standardError)
        additionalStatistics.push('se');
    if (statistics.confidenceInterval)
        additionalStatistics.push('ci');
    if (additionalStatistics.length > 0)
        parameters.push({ queryCode: 'a', value: additionalStatistics.join(',') });

    if (statistics.chiSquare)
        parameters.push({ queryCode: 'chi', value: 'true' });
    if (statistics.nonResponse)
        parameters.push({ queryCode: 'nr', value: 'true' });
    if (statistics.sampleSize)
        parameters.push({ queryCode: 'ss', value: 'true' });
}

function getReportParameters(selectionModel) {
    var parameters = [];
    commonApiHelper.addServiceParameters(parameters, process.env.VUE_APP_CT_SAS_PROGRAM);
    apiHelper.addSelectionParameters(parameters, selectionModel);
    parameters.push({ queryCode: 'output_format', value: 'json' });
    return commonApiHelper.toQueryString(parameters)
}

function getJsonFileName(selectionModel) {
    var parameters = [];
    apiHelper.addSelectionParametersSmall(parameters, selectionModel);
    return commonApiHelper.toQueryString(parameters) + '.json';
}

function loadCachedData(vm, apiFormData, showUnweighted, $router) {

    var downloadedJsonUrl = apiHelper.getJsonFileName(current.selectionModel);
    $.ajax({
        url: 'static/apiCache/' + downloadedJsonUrl,
        type: 'GET',
        dataType: 'json',
        cache: false,
        async: false,
        success: function (data) {
            apiHelper.populateReportModel(data, vm);
            commonTestHelper.nextIfTesting($router, true);
        },
        error: function (jqXHR) {
            apiHelper.loadFromApi2(vm, apiFormData, false, $router, downloadedJsonUrl)
        }
    });
}

function saveLogData(data) {
    if (!data || data.errorMessages.length === 0) {
        var logData = {
            selectionModel: current.selectionModel,
            executionTime: data ? data.recordTotals.executionTime.trim() : '0'
        };
        //commonApiHelper.saveLogData(logData);
    }

}

function loadFromApi(vm, apiFormData, showUnweighted, $router) {
    if (apiHelper.loadFromCachedData)
        apiHelper.loadCachedData(vm, apiFormData, showUnweighted, $router)
    else
        apiHelper.loadFromApi2(vm, apiFormData, showUnweighted, $router)
}

function loadFromApi2(vm, apiFormData, showUnweighted, $router, downloadedJsonUrl) {
    var selectionModel = current.selectionModel;
    store.dispatch('results/startCtAnalysis', { apiFormData, selectionModel });
    store.dispatch('selModel/startCtAnalysis', {});
    var timeoutSeconds = 0; // No limit
    store.dispatch('display/setIsLoading', true);
    $.ajax({
        url: process.env.VUE_APP_SAS_BROKER,
        type: 'POST',
        timeout: timeoutSeconds * 1000,
        data: apiFormData,
        success: function (data) {
            store.dispatch('display/setIsLoading', false);
            if (apiHelper.loadFromCachedData && downloadedJsonUrl)
                apiHelper.downloadJson(data, downloadedJsonUrl);
            metricsHelper.reportLoaded();
            var links = store.state.display.breadCrumbLinks;
            var onReportPage = links.length > 0 && links[links.length-1].name === 'crossTabulationViewReport';
            const results = store.state.results;
            if (results.analysisType === 'ct' && results.apiFormData === apiFormData && results.loadingData) {
                // if (process.env.NODE_ENV === 'development')
                //   apiHelper.loadFromApiCompare(vm, apiFormData, showUnweighted);
                store.dispatch('results/loadedData', { apiFormData, data });
                if (!onReportPage)
                    store.dispatch('display/setReportLoadedMessage');
            }
            if (onReportPage)
                apiHelper.populateReportModel(data, vm);
            //apiHelper.saveLogData(data);  //Save file for calculating execution time.  Runs only locally
            commonTestHelper.nextIfTesting($router, true);
        },
        error: function (jqXHR) {
            console.log('API Error', jqXHR);
            metricsHelper.reportFailed();
            vm.errorCode = 'ajax';
            store.dispatch('display/setIsLoading', false);
            commonTestHelper.nextIfTesting($router, false);
        }
    });
}

function loadFromApiCompare(vm, apiFormData, showUnweighted, $router, downloadedJsonUrl) {
    var selectionModel = current.selectionModel;
    store.dispatch('results/startCtAnalysis', { apiFormData, selectionModel });
    store.dispatch('selModel/startCtAnalysis', {});
    var timeoutSeconds = 0; // No limit
    store.dispatch('display/setIsLoading', true);
    $.ajax({
        url: process.env.VUE_APP_SAS_BROKER, // 'brfss_p.ctIntegration.sas',
        type: 'POST',
        timeout: timeoutSeconds * 1000,
        data: apiFormData.replace('brfss_p.ct', 'brfss_p.ctIntegration'),
        success: function (ctIntegrationData) {
            if (ctIntegrationData.errorMessages.length == 0) {
                compare(vm.reportModel.originalData, ctIntegrationData);
                // console.log(newData, oldData);
            }
            store.dispatch('display/setIsLoading', false);
        },
        error: function (jqXHR) {
            console.log('API Error', jqXHR);
            metricsHelper.reportFailed();
            vm.errorCode = 'ajax';
            store.dispatch('display/setIsLoading', false);
            commonTestHelper.nextIfTesting($router, false);
        }
    })
}

function downloadJson(downloadedData, jsonFileName) {
    var vm = this;
    const data = JSON.stringify(downloadedData);
    const blob = new Blob([data], { type: "text/plain" });
    const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
    //a.download = vm.apiQueryString + '.json';
    //a.download = apiHelper.getJsonFileName(current.selectionModel);
    a.download = jsonFileName;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
    e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
    );
    a.dispatchEvent(e);
}

function populateReportModel(data, vm) {
    if (process.env.NODE_ENV === 'development' && !data.errorMessages)
        console.log('apiHelper.populateReportModel invalid api results', data)
    if (data.errorMessages.length > 0) {
        vm.errorCode = '1';
        vm.errorMessages = data.errorMessages;
    } else {
        vm.reportModel = reportModelBuilder.build(data);
        vm.testRow = vm.reportModel.levelsGroupedByControl1[0].levelsGroupedByControl2[0].levelsGroupedByRows[0];
        vm.testColumn = vm.testRow.columns[0];
        vm.reportModel.originalData = data;
        vm.errorMessages = [];
    }
    // console.log("created2", levelCounts);
    store.dispatch("loadedControls/startReport", {
        levelCounts: getTheLevelCounts(vm.reportModel),
    });

    store.dispatch('display/setIsLoading', false);
}

function getTheLevelCounts(reportModel) {
    //console.log("vm.reportModel", reportModel.levelsGroupedByControl1);
    const l1 = current.selectionModel.v.control1.include ? reportModel.levelsGroupedByControl1.length : 1;
    const l2 = current.selectionModel.v.control2.include ? reportModel.levelsGroupedByControl1[0].levelsGroupedByControl2.length : 1;
    return [l1, l2];
}



// function formatName(name, cti) {
//   return '[' + cti + '].' + name;
// }
function logDiff(newData, oldData, parms) {
    console.log(
        (parms.cti || parms.cti === 0 ? 'crosstab[' + parms.cti + '].' : '')
        + (parms.sti || parms.sti === 0 ? 'statistic[' + parms.sti + '].' : '')
        + (parms.name ? parms.name : '')
        + (parms.name2 ? ' ' + parms.name2 : '')
        + ' doesn\'t match ('
        + newData
        + ', '
        + oldData
        + ')')
}
function compareLevel(name, newData, oldData, parms) {
    parms.name = name;
    if (!oldData[name].level) {
        oldData[name].level = 0;
        oldData[name].areAllLevelsIncluded = true;
    }
    compareValue('level', newData[name], oldData[name], parms);
    compareValue('areAllLevelsIncluded', newData[name], oldData[name], parms);
    parms.name = null;
}

function compareValueWithMissing(name, newData, oldData, parms) {
    parms.name2 = name;
    if (!newData && !oldData)
        return;
    if (!newData || !oldData)
        logDiff(newData, oldData, parms);
    else {
        if (!newData)
            console.log('New Data is null', parms);

        if (newData[name] === 'null' && (newData.isMissing || newData.isSampleTooSmall)
            && (newData.isMissing === oldData.isMissing && newData.isSampleTooSmall == oldData.isSampleTooSmall))
            return;
        if (!newData[name] && !oldData[name])
            return;
        // if (!oldData[name])
        if (newData[name] !== oldData[name]) {
            logDiff(newData[name], oldData[name], parms);
        }
    }
    parms.name2 = null;
}

function compareValue(name, newData, oldData, parms) {
    parms.name2 = name;
    if (!newData && !oldData)
        return;
    if (!newData[name] && !oldData[name])
        return;
    if (newData[name].toString() !== oldData[name].toString())
        logDiff(newData[name], oldData[name], parms);
    parms.name2 = null;
}

function compareStatistic(name, newData, oldData, parms) {
    parms.name = name;
    compareValueWithMissing('value', newData[name], oldData[name], parms);
    compareValueWithMissing('standardError', newData[name], oldData[name], parms);
    compareValueWithMissing('confidenceInterval', newData[name], oldData[name], parms);
    compareValue('isMissing', newData[name], oldData[name], parms);
    compareValue('isSampleTooSmall', newData[name], oldData[name], parms);
    parms.name = null;

}

function compareStatistics(newData, oldData, parms, sti) {
    parms.sti = sti;
    compareLevel('rowVariable', newData, oldData, parms);
    compareLevel('columnVariable', newData, oldData, parms);
    compareValue('sampleSize', newData, oldData, parms);
    compareStatistic('weightedN', newData, oldData, parms);
    compareStatistic('rowPercentage', newData, oldData, parms);
    compareStatistic('columnPercentage', newData, oldData, parms);
    compareStatistic('totalPercentage', newData, oldData, parms);
    parms.sti = null;
}

function compareCrossTabulation(newData, oldData, cti) {
    let parms = {
        cti: cti
    };
    compareLevel('controlVariable1', newData, oldData, parms);
    compareLevel('controlVariable2', newData, oldData, parms);
    newData.statistics.forEach((st, sti) => compareStatistics(st, oldData.statistics[sti], parms, sti));
}

function compare(newData, oldData) {
    newData.crossTabulations.forEach((ct, cti) => compareCrossTabulation(ct, oldData.crossTabulations[cti], cti));
}

function callGet({
    url,
    //apiUrl,
    data,
    success,
    error,
    dataType,
    contentType,
    processData,
    isLogin
}) {
    const type = 'GET';

    if (process.env.useCachedApi) {
        loadCachedData(type, url, success);
    } else {
        //const fullUrl = apiUrl ? (process.env.BASE_URL + '/api' + apiUrl) : url;
        const xhr = createCORSRequest(url);
        xhr.withCredentials = true;

        xhr.onreadystatechange = function () {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    var response = getResponse(xhr.responseText);
                    window.response = xhr.getAllResponseHeaders().split('\r\n');
                    store.dispatch('security/setAntiForgeryToken', {
                        headers: getHeaders(xhr)
                    });
                    save(type, url, response);
                    if (success) success(response);
                } else {
                    if (error) error(xhr.responseText);
                }
            }
        };

        xhr.setRequestHeader('accept', 'application/json');
        // xhr.setRequestHeader('x-pingover', 'forcePreflight');
        if (
            type.toLowerCase() === 'post' &&
            store.state.security.antiForgeryToken
        ) {
            xhr.setRequestHeader(
                'requestverificationtoken',
                store.state.security.antiForgeryToken
            );
            xhr.setRequestHeader('x-pingover', 'forcePreflight');
        }
        if (contentType) xhr.setRequestHeader('content-type', contentType);

        xhr.timeout = 10000;

        if (data)
            xhr.send(
                processData == undefined || processData
                    ? JSON.stringify(data)
                    : data
            );
        else xhr.send();

        //Add
        // processData,
        // dataType: dataType,
        //Error handler
    }
}
//https://www.html5rocks.com/en/tutorials/cors/

const urls = {
    datalists_stateYearCounts: "/weat/static/datalists/stateYearCounts.json",
    datalists_variables: "/weat/static/datalists/variables.json",
    //datalists_variables2021: "/weat/static/datalistsNew/variables.json",
    datalists_years: "/weat/static/datalists/years.json",
    datalists_states: "/weat/static/datalists/states.json"
}


function getXhr() {
    var xhr = new XMLHttpRequest();
    if ('withCredentials' in xhr)
        return xhr;

    if (typeof XDomainRequest != 'undefined')
        return new XDomainRequest(); 

    // CORS not supported.
    return null;
}

function createCORSRequest(datalistname) {
    
    const method = 'GET';
    //process.env.BASE_URL + 
    //var theUrl = process.env.VUE_APP_FOLDER + urls[datalistname];
    var theUrl = process.env.BASE_URL + urls[datalistname];
    
    //console.log('createCORSRequest', datalistname);
    
        switch (datalistname) {
            case 'datalists_stateYearCounts': return xhrOpen('GET', '/weat/static/datalists/stateYearCounts.json', true);
            case 'datalists_variables': return xhrOpen('GET', '/weat/static/datalists/variables.json', true);
            //case 'datalists_variables2021': return xhrOpen('GET', '/weat/static/datalistsNew/variables.json', true);
            case 'datalists_years': return xhrOpen('GET', '/weat/static/datalists/years.json', true);
            case 'datalists_states': return xhrOpen('GET', '/weat/static/datalists/states.json', true);
        default: 
            console.log('Unknown API call for ' + datalistname)
            return null;
        }

    //return xhr;
}

function xhrOpen(type, name, boolValue) {
    var xhr = getXhr();
    if (!xhr)
        return null;

    xhr.open(type, name, boolValue);
    return xhr;

}

function save(type, url, data) {
    let vm = this;
    let fileName = getCachedFileName(type, url) + '.json';
    let results = JSON.stringify(data);
}

function getResponse(responseText) {
    if (responseText && responseText !== '') return JSON.parse(responseText);
    else return {};
}

function getHeaders(getUrl) {
    window.response = getUrl.getAllResponseHeaders().split('\r\n');
    let headers = Object.assign(
        ...getUrl
            .getAllResponseHeaders()
            .split('\r\n')
            .map(h => toKeyValuePair(h.split(': ')))
            .filter(h => h)
    );
    return headers;
}

function toKeyValuePair(h) {
    if (!h || h.length === 0 || h[0] === '') return null;
    return { [h[0]]: h.length > 1 ? h[1] : '' };
}
function getCachedFileName(type, url) {
    let parts = url.split('?');
    let api = parts[0];
    let parms = parts.length > 1 ? parts[1] : '';
    return (
        type.toLowerCase() + api.replace(/\//g, '-').toLowerCase() + '-' + parms
    );
}
